module.exports = __webpack_public_path__ + "media/applicants/dropdown-b37af177.png";